import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { BrowserModule } from "@angular/platform-browser";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextareaModule } from "primeng/inputtextarea";

import { AppSharedModule } from "../../shared/app-shared.module";
import { OneCardExpressRoutes } from "./OneCardExpress-routes";
import { OneCardExpressComponent } from "./index";

import { ExpressComponent } from "./express/express.component";
import { AddComponent } from "./express/add/add.component";

import { ExpressAdminComponent } from "./expressadmin/expressadmin.component";
import { StatusComponent } from "./expressadmin/status/status.component";

import { PersonSelectorModule } from "../personselector/personselector.module";

import { DataService_express } from "./express/shared/data.service";
import { DataService_expressadmin } from "./expressadmin/shared/data.service";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

@NgModule({
	declarations: [OneCardExpressComponent, ExpressComponent, AddComponent, ExpressAdminComponent, StatusComponent],
	imports: [
		BrowserModule,
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		InputTextareaModule,
		SchoolselectorModule,
	],
	providers: [DatePipe, ConfirmationService, DataService_express, DataService_expressadmin],
})
export class OneCardExpressModule {}
